//#region Imports
/**
 * To use react functionality
 */
import React, { useState } from "react";
/**
Allows component  to connect the Redux store.
*/
import { connect } from "react-redux";
/**
 * 
The Suspense component in React is used to display a fallback UI while asynchronous data is loading. 
This can be used to improve the user experience by preventing the UI from being blocked while the data is loading.
 */
import { Suspense } from "react";
/**
 * To use wrapper componnent
 */
import withLoading from "../shared/withLoading";
/**
 * To show trip details
 */
import TripDetails from "./TripDetails";
/**
 * To show spinner while data is loading
 */
import Spinner from "../shared/Spinner";

/**
 * load Map component lazily
 */
const Map = React.lazy(() => import("../Map/index"));

//#endregion

const PrintPage = (props) => {

  //#region variable declaration starts

  //stores props property
  const { trips, currentTrip } = props;

  //stores map is visible or not value
  const [isVisible, setIsVisible] = useState(true);
  //#endregion

  //#region Method declaration starts

  //triggers before print windows opens
  //hide buttons buttons
  var beforePrint = () => {
    addOrRemoveCSSClass(false, "btnBack", "display-inline");
    addOrRemoveCSSClass(false, "btnPrintDetail", "display-inline");
    addOrRemoveCSSClass(false, "btnShowHideMap", "display-inline");
    addOrRemoveCSSClass(true, "btnBack", "display-none");
    addOrRemoveCSSClass(true, "btnPrintDetail", "display-none");
    addOrRemoveCSSClass(true, "btnShowHideMap", "display-none");
  };

  //triggers after print windows close
  var afterPrint = () =>  {
    addOrRemoveCSSClass(false, "btnBack", "display-none");
    addOrRemoveCSSClass(false, "btnPrintDetail", "display-none");
    addOrRemoveCSSClass(false, "btnShowHideMap", "display-none");
    addOrRemoveCSSClass(true, "btnBack", "display-inline");
    addOrRemoveCSSClass(true, "btnPrintDetail", "display-inline");
    addOrRemoveCSSClass(true, "btnShowHideMap", "display-inline");
  };
  //bind windows event for print
  window.onbeforeprint = beforePrint;
  window.onafterprint = afterPrint; 

  //Set visiblity for Map
  const setVisiblity = () => {
    //save value in localstorate for future use
    localStorage.setItem("IsFromPrintPage", "True");
    //set visibility of the map 
    setIsVisible(!isVisible);
  };

  /**
  * It is written in Printview>>Index .
  * Used in same component.
  * Add and Removes Css class
  * @param {String} 'flag to add or remove css class '
  * @param {String} 'Html control id'
  * @param {String} 'CSS class name to add or remove'
  */
  //
  const addOrRemoveCSSClass = (isForAdd, controlId, className) => {
    //gets html element reference object
    let controlRef = document.getElementById(controlId);
    //check objecet is not null
    if (controlRef != null && controlRef !== undefined) {
      //weather to add css class or remove
      if (isForAdd) {
        //Add css class 
        controlRef.classList.add(className);
      } else {
        //remove css class 
        controlRef.classList.remove(className);
      }
    }
  };

  //Show hide map
  const showHideMap = () => {
    return (
      <Suspense fallback={<Spinner />}>
        <div className={isVisible ? "display-inline" : "display-none"}>
          <Map />
        </div>
      </Suspense>
    );
  };

  //#endregion 

  //#region return component html

  return (
    <div className="otp-directions">
      <h2>Your Trip Details</h2>
      <div
        className="otp-button-primary otp-edit-button print-btn-container"
      >
        <button id="btnBack" className="otp-icon-wrapper" onClick={() =>  window.location.reload()}>
          Back
        </button>
        <button id="btnPrintDetail" className="otp-icon-wrapper" onClick={() => window.print()}>
          Print Trip
        </button>
        <button id="btnShowHideMap" onClick={() => setVisiblity()}>
          Show/Hide Map
        </button>
      </div>
      <TripDetails        
        trips={trips}
        currentTrip={currentTrip}
        label={currentTrip}
      />
      {showHideMap()}
    </div>
  );

  //#endregion
};

//#region store related functions

//Stores values for Trips and Current trip
const mapStateToProps = (state) => {
  return {
    //Controls comes from directionsReducer
    trips: state.directions.trips,
    //current trip details
    currentTrip: state.directions.currentTrip,
  };
};

/**
 * The function takes a single argument, which is the PrintPage component. 
 * The function then returns a new component that is wrapped in the withLoading component.
 */
const WrappedDirections = withLoading({ text: "Loading Directions..." })(
  PrintPage
);

//#endregion

export default connect(mapStateToProps)(WrappedDirections);
